import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createAddDocApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { initialAdditionalDocApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import {
  setStepApplicantEdited,
  setRequestIdentifier,
  completeApplicantStep,
} from "../../../../../../store/redux/slice/Forms/libservAdditionalDocForm";
import AdditionalDocApplicantDetailsForm from "../../../common/form/applicant/AdditionalDocApplicantDetailsForm";

const LibservAdditionalDocStepApplicant = () => {
  const libservAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.LibservAdditionalDocForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    libservAdditionalDocForm,
    baseEndpointPaths.libservAdditionalDoc,
    createAddDocApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialAdditionalDocApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset("LIBSERV_ADDITIONAL_DOCUMENTS", libservAdditionalDocForm.applicantDetails, methods.reset);

  return <AdditionalDocApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default LibservAdditionalDocStepApplicant;
